import { Injectable } from "@angular/core";
import { RouterQuery } from "@datorama/akita-ng-router-store";

import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

export interface RouterStateInterface {
  getState(): Observable<any>;
  getRouteUrlSegments(): Observable<Array<string>>;
  getRouteLayout(): Observable<string>;
}

@Injectable()
export class RouterState implements RouterStateInterface {
  constructor(private query: RouterQuery) {}

  getState(): Observable<any> {
    return this.query.select((state) => state.state);
  }

  getRouteUrlSegments(): Observable<Array<string>> {
    return this.query
      .select((state) => state.state)
      .pipe(
        filter((state) => !!state),
        map((state) => {
          const path = state.url.replace(/^\/+|\/+$/g, "");
          const pathArr = path.split("/");
          return pathArr;
        })
      );
  }

  getRouteLayout(): Observable<string> {
    return this.query
      .select((state) => state.state)
      .pipe(
        filter((state) => !!state),
        map((state) =>
          state.root && state.root.data && state.root.data.layout
            ? state.root.data.layout
            : "default"
        )
      );
  }
}
